import memoize from 'lodash/memoize';

import get from 'lodash/get';

import { ArticleRating } from 'types';

export default memoize(
  (articleRating: unknown): ArticleRating => {
    return {
      rating: get(articleRating, 'upvotes', 0),
    };
  }
);
